import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { selectedCompanyStorage } from '../../storage/company/selected-company.util';
import { VestingTask } from '../../types/vesting-tasks.types';
import { useAppQuery } from '../use-app-query.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export enum TargetBasedVestingHookMode {
  CHECK_EXIST = 'check-exist',
  GET_DATA = 'get-data',
}

export const useTargetBasedVesting = <
  TMode extends TargetBasedVestingHookMode = TargetBasedVestingHookMode.GET_DATA,
>({
  mode = TargetBasedVestingHookMode.GET_DATA,
}: {
  mode: TargetBasedVestingHookMode;
}) => {
  const companyId = selectedCompanyStorage(({ companyId }) => companyId);
  const { invalidateQuery } = useInvalidateQueries(
    QueryKey.GET_APPROVE_TARGET_BASED_UNFINISHED_VESTING_TASKS,
  );

  const { data: targetBasedVesting, isLoading } = useAppQuery<
    TMode extends TargetBasedVestingHookMode.GET_DATA ? VestingTask[] : { isValid: boolean }
  >({
    enabled: !!companyId,
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [
          companyId,
          'share-plans',
          mode === TargetBasedVestingHookMode.CHECK_EXIST
            ? 'is-exist-target-based-unfinished-tasks'
            : 'target-based-unfinished-tasks',
        ],
      }),
    queryKey: [QueryKey.GET_APPROVE_TARGET_BASED_UNFINISHED_VESTING_TASKS, companyId, mode],
  });

  return {
    invalidateQuery,
    isLoading,
    targetBasedVesting,
  };
};
